// Folds a bundle's choosable-component options into the buybox "What's Included" table. Resolves the
// combined variant from EVERY checked radio (via the emitted variant map, not a per-swatch baked id,
// so multiple choosable components can't clobber each other), sets the form variant directly (no
// section re-render, so the custom UI survives) and swaps the row thumbnail. Delegated at document level.
(() => {
  // Map + radios + form are all read within the interacted section, so a second bundle on the same
  // page (quick view, multi-bundle) resolves against its own map, never the first one in the DOM.
  const readVariantMap = (scope) => {
    const mapEl = scope.querySelector('[data-bundle-variant-map]');
    if (!mapEl || !mapEl.textContent) return {};
    try {
      return JSON.parse(mapEl.textContent);
    } catch (error) {
      return {};
    }
  };

  // Combination key from the checked radio of every option, so the variant reflects all dimensions
  // at once (e.g. kettlebell weight AND mat colour).
  const resolveVariant = (scope) => {
    const variantMap = readVariantMap(scope);
    const selectedByPosition = {};
    scope.querySelectorAll('.bundle-summary__swatch-input:checked[data-option-position]').forEach((input) => {
      selectedByPosition[input.dataset.optionPosition] = input.dataset.value;
    });
    const positions = Object.keys(selectedByPosition).sort((first, second) => first - second);
    if (!positions.length) return null;
    return variantMap[positions.map((position) => selectedByPosition[position]).join('||')] || null;
  };

  const setFormVariant = (scope, variantId) => {
    // Clear the id on an unavailable combination so the theme disables ATC, rather than leaving a stale valid variant that would add the wrong item.
    scope.querySelectorAll('form[id^="product-form-"] input[name="id"]').forEach((input) => {
      input.value = variantId || '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.bundle-summary__swatch-input');
    if (!input) return;
    const scope = input.closest('[id^="shopify-section-"]') || document;

    const row = input.closest('.bundle-summary__item');
    const thumb = row && row.querySelector('img.bundle-summary__thumb');
    if (thumb && input.dataset.swatchImage) {
      thumb.removeAttribute('srcset');
      thumb.src = input.dataset.swatchImage;
    }

    setFormVariant(scope, resolveVariant(scope));
  });

  // Hide the native buybox picker only where swatches exist, so it stays a no-JS fallback. Re-checked
  // on section load so a bundle rendered dynamically (theme editor, quick view) activates too.
  const activate = () => {
    if (document.querySelector('.bundle-summary__swatch-input')) {
      document.documentElement.classList.add('bundle-swatches-active');
    }
  };
  activate();
  document.addEventListener('shopify:section:load', activate);
})();
